// Maps a page link to the same 4-color playful palette used by the nav
// categories (see the "Colors (nav palette)" custom-css entry / Navigation.tsx
// PLAYFUL_PALETTE), so homepage teasers/CTAs read as "part of" the section of
// the site they link into instead of a disconnected generic green button.
const LINK_COLOR: Record<string, 'blue' | 'gold' | 'red' | 'green'> = {
  '/konzept': 'blue',
  '/leitbild': 'blue',
  '/profil': 'blue',
  '/montessori': 'blue',
  '/grunwald': 'blue',
  '/schulweg': 'green',
  '/termine-ferien': 'green',
  '/schulregeln': 'red',
  '/projekte': 'red',
  '/aktuelles': 'blue',
};

export function colorForLink(link?: string): 'blue' | 'gold' | 'red' | 'green' {
  if (!link) return 'blue';
  return LINK_COLOR[link] || 'blue';
}
